import { render, staticRenderFns } from "./VideoCallPopup.vue?vue&type=template&id=773ef992&scoped=true"
import script from "./VideoCallPopup.vue?vue&type=script&lang=js"
export * from "./VideoCallPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ef992",
  null
  
)

export default component.exports